<ng-container>
    <ng-content></ng-content>
</ng-container>
